<template>
	<div class="comment-block comments-normal">
		<comment-item
			v-for="(item, index) of comments"
			:item="item"
			:key="item.id">
		</comment-item>
	</div>
</template>

<script>
import CommentItem from './comment-item'
export default {
	components: {
		CommentItem
	},
	props: ['comments']
	
}
</script>


// WEBPACK FOOTER //
// comment-block.vue?c272ce2a